import { MorningChoice } from "./MorningChoice";
import { FocusPanel } from "./FocusPanel";
import { EveningClose } from "./EveningClose";
import { OptionalContent } from "./OptionalContent";

export function StatusPill({ view }) {
  return (
    <div className="mt-4 flex flex-wrap items-center gap-2 text-sm" data-testid="c2g-status">
      <span className="text-[#8A8E96]">Stato del passo:</span>
      <span className="rounded-full border border-[#D4AF37]/40 bg-[#D4AF37]/10 px-3 py-1 font-semibold text-[#F4F4F5]" data-testid="c2g-status-label">{view.status_label}</span>
      {view.record?.restartedAfterSkip && <span className="rounded-full border border-[#27272A] px-3 py-1 text-[#B4B4BC]" data-testid="c2g-restart-flag">Ripresa dopo una pausa</span>}
    </div>
  );
}

export function EngineDay({ view, times, onAction }) {
  const { day, record: rec, editable } = view;
  return (
    <div className="space-y-3" data-testid="c2g-day">
      <MorningChoice key={`m-${rec?.selectedStep?.choiceId}`} m={day.morning} rec={rec} editable={editable} time={times?.mattino} onAction={onAction} />
      <FocusPanel f={day.focus} rec={rec} editable={editable} time={times?.focus} tz={view.tz} onAction={onAction} />
      <EveningClose key={`e-${rec?.selectedStep?.choiceId}`} e={day.evening} rec={rec} editable={editable} time={times?.sera} onAction={onAction} />
      <OptionalContent key={view.day_number} oc={day.optional_content} />
    </div>
  );
}
